import jsgc from './jsgc';
import zfcg from './zfcg';

export default {
    path: 'zbgg',
    component: () => import(/*webpackChunkName: 'bidding-fabiao'*/ '@layout/empty'),
    children: [
        jsgc,
        zfcg
    ]
}